import { attributeNames } from "./variables";
import percentile from "percentile";

function getDbThres(dbData, thresMin, thresMax) {
  var attMinDict = {};
  var attMaxDict = {};

  attributeNames.map((att, index) => {
    //find min and max thresholds for each attribute based on landscape
    const resultMin = percentile(thresMin, dbData, (item) => item[att]);
    attMinDict[att] = resultMin[att];
    const resultMax = percentile(thresMax, dbData, (item) => item[att]);
    attMaxDict[att] = resultMax[att];

    return null;
  });

  return { attMinDict, attMaxDict };
}

function calcAttDistance(dataSend, record) {
  const distanceArray = [];
  attributeNames.map((att, index) =>
    distanceArray.push(Math.pow(dataSend[att] - record[att], 2))
  );

  const distance = Math.sqrt(
    distanceArray.reduce((acc, next) => acc + next, 0)
  );

  return distance;
}

function getProximityUnscripted(attMinDict, attMaxDict, selectedOption) {
  if (selectedOption.length === 1) {
    selectedOption = [selectedOption[0], selectedOption[0]];
  }

  var attMinDictSelected = {};
  var attMaxDictSelected = {};

  attributeNames.map((att, index) => {
    //find min and max for each attribute
    attMinDictSelected[att] = selectedOption.reduce((prev, curr) => {
      return prev[att] < curr[att] ? prev[att] : curr[att];
    });

    attMaxDictSelected[att] = selectedOption.reduce((prev, curr) => {
      return prev[att] > curr[att] ? prev[att] : curr[att];
    });

    return null;
  });

  var blendAtt = {};
  attributeNames.map((att, index) => {
    const thresMinValue = attMinDict[att];
    const thresMaxValue = attMaxDict[att];

    const optionsMinValue = selectedOption.reduce((prev, curr) => {
      return prev[att] < curr[att] ? prev[att] : curr[att];
    });
    const optionsMaxValue = selectedOption.reduce((prev, curr) => {
      return prev[att] > curr[att] ? prev[att] : curr[att];
    });

    var blendValue;

    if (
      (optionsMinValue <= thresMinValue && optionsMaxValue >= thresMaxValue) ||
      (optionsMinValue >= thresMinValue && optionsMaxValue <= thresMaxValue)
    ) {
      // If neither min_thresh or max_thresh is reached, or if both are reached, take the mean.
      blendValue =
        selectedOption.reduce((total, next) => total + next[att], 0) /
        selectedOption.length;
    } else {
      // Otherwise, take the extreme.

      if (optionsMinValue <= thresMinValue) {
        blendValue = optionsMinValue;
      } else {
        blendValue = optionsMaxValue;
      }
    }

    blendAtt[att] = blendValue;

    return blendAtt;
  });

  return blendAtt;
}

export { getDbThres, getProximityUnscripted, calcAttDistance };
